import { http } from '../utils/http';

export const listUsers = (signal) => http.get('/admin/users', { signal });

export const createUser = (payload, signal) =>
    http.post('/admin/users', payload, { signal });

export const updateUser = (userId, payload, signal) =>
    http.put(`/admin/users/${userId}`, payload, { signal });

export const deleteUser = (userId, signal) =>
    http.delete(`/admin/users/${userId}`, { signal });

export const getUserPermissions = (userId, signal) =>
    http.get(`/admin/users/${userId}/permissions`, { signal });

export const updateUserPermissions = (userId, payload, signal) =>
    http.put(`/admin/users/${userId}/permissions`, payload, { signal });

export const listDevices = (signal) => http.get('/admin/devices', { signal });

export const createDevice = (payload, signal) =>
    http.post('/admin/devices', payload, { signal });

export const updateDevice = (deviceId, payload, signal) =>
    http.put(`/admin/devices/${deviceId}`, payload, { signal });

export const deleteDevice = (deviceId, signal) =>
    http.delete(`/admin/devices/${deviceId}`, { signal });
